export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "quality_sampling_groups": {
            "average": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promedio"])},
            "min_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mínimo"])},
            "max_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Máximo"])}
          }
        }
      },
      "en": {
        "model": {
          "quality_sampling_groups": {
            "average": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average"])},
            "min_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min Value"])},
            "max_value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max Value"])}
          }
        }
      }
    }
  })
}